"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SvgGroup = function SvgGroup(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 44",
    xmlSpace: "preserve",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#37D5D3",
    cx: 36.98,
    cy: 33.346,
    rx: 11.02,
    ry: 10.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FD8460",
    cx: 23.788,
    cy: 10.48,
    rx: 10.808,
    ry: 10.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#79C9FC",
    cx: 10.808,
    cy: 33.346,
    rx: 10.808,
    ry: 10.48
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.808 35.189c-3.601 0-6.651 2.309-7.707 5.498 1.961 1.936 4.688 3.139 7.707 3.139s5.746-1.203 7.707-3.139c-1.056-3.189-4.105-5.498-7.707-5.498z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.788,
    cy: 7.682,
    rx: 3.378,
    ry: 3.315
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.98 35.189c-3.672 0-6.78 2.309-7.856 5.498 1.999 1.936 4.779 3.139 7.856 3.139 3.078 0 5.859-1.203 7.858-3.14-1.076-3.188-4.185-5.497-7.858-5.497z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.808,
    cy: 30.548,
    rx: 3.378,
    ry: 3.315
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.981,
    cy: 30.548,
    rx: 3.443,
    ry: 3.315
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.788 20.96c3.02 0 5.746-1.203 7.707-3.139-1.056-3.189-4.104-5.497-7.707-5.497-3.601 0-6.65 2.308-7.707 5.498a10.94 10.94 0 0 0 7.707 3.138z"
  })));
};

var _default = SvgGroup;
exports["default"] = _default;